import { render, staticRenderFns } from "./channelUnit.vue?vue&type=template&id=32e37a90&scoped=true"
import script from "./channelUnit.vue?vue&type=script&lang=js"
export * from "./channelUnit.vue?vue&type=script&lang=js"
import style0 from "./channelUnit.vue?vue&type=style&index=0&id=32e37a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e37a90",
  null
  
)

export default component.exports